<template>
  <a-spin :spinning="spinning" wrapperClassName="spin-wrap">
    <div class="m-login">
      <div class="u-login-bg"></div>
      <div class="m-login-content-wrap">
        <div class="m-login-content-imgs">
          <img src="../../assets/images/login/login-img.png" alt class="u-login-img" />
          <img src="../../assets/images/login/login-cube1.png" alt class="u-login-cube1" />
          <img src="../../assets/images/login/login-shadow.png" alt class="u-login-shadow1" />
          <img src="../../assets/images/login/login-cube2.png" alt class="u-login-cube2" />
          <img src="../../assets/images/login/login-shadow.png" alt class="u-login-shadow2" />
          <img src="../../assets/images/login/login-cube2.png" alt class="u-login-cube3" />
          <img src="../../assets/images/login/login-shadow.png" alt class="u-login-shadow3" />
        </div>

        <div class="m-login-content-box">
          <div class="m-login-box-wrap">
            <div class="u-login-box-title">
              <img
                src="../../assets/images/login/QFAD-logo.png"
                alt="亲邻邻盟"
                style="width:100%;"
              />
            </div>

            <div class="tab_wrapper">
              <a-tabs v-model="activeKey" :animated="true" @change="changeLoginType">
                <a-tab-pane key="1" tab="手机登录">
                  <PhoneLoginForm :loginType="activeKey" />
                </a-tab-pane>

                <a-tab-pane key="2" tab="扫码登录">
                  <!-- 微信扫码 -->

                  <template v-if="scanCodeStep === 1">
                    <a-spin tip="拼命获取二维码..." :spinning="!isGetWxLoginCode">
                      <div class="wx_code_wrapper">
                        <div id="wx_login_qrcode" class="wx_login_qrcode"></div>
                      </div>
                    </a-spin>

                    <div class="check_agree_box">
                      <a-checkbox :checked="isCheckAgree" @change="handleChangeAgree">
                        登录即代表同意<a
                          target="_blank"
                          style="color: #1890ff"
                          :href="settings.loginAgreement.url"
                        >
                          《{{ settings.loginAgreement.name }}》
                        </a>
                      </a-checkbox>
                    </div>
                  </template>

                  <!-- 首次扫码，绑定手机号 -->
                  <PhoneLoginForm v-else :loginType="activeKey" :wxUserInfo="wxUserInfo" />
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>
          <div class="u-login-box-footer">
            <!-- <p>copyright &copy; 2019 Qinlin technology. All rights reserved. 粤ICP备15007183号</p> -->
            <p>
              深圳市亲邻科技有限公司 版权所有
              <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备15007183号</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择登录账号-弹窗 -->
    <ChooseLoginAccountModal ref="chooseLoginAccountModalRef" @choose="selectCompany" />
  </a-spin>
</template>
<script>
import { api } from '../../commomFun/api'
import cookie from '../../commomFun/cookie.js'
import PhoneLoginForm from './components/phoneLoginForm.vue'
import settings from '@/settings'
import * as loginApi from '@/api/login.api'
import ChooseLoginAccountModal from './components/chooseLoginAccountModal.vue'

export default {
  components: { PhoneLoginForm, ChooseLoginAccountModal },
  data() {
    return {
      settings,
      isCheckAgree: false,
      checkNick: false,
      form: this.$form.createForm(this),
      spinning: false,
      // 扫码登录步骤 1：获取微信登录二维码 2：首次扫码，绑定手机号
      scanCodeStep: 1,
      // 是否获取微信登录二维码
      isGetWxLoginCode: false,
      // 登录方式 1：手机登录 2：扫码登录
      activeKey: '1',
      // 微信用户信息
      wxUserInfo: {
        unionId: '',
        openId: ''
      },
      wxLoginState: null
    }
  },
  methods: {
    handleChangeAgree(e) {
      this.isCheckAgree = e.target.checked
    },

    /**
     * 切换登录方式
     */
    changeLoginType() {
      this.isGetWxLoginCode = false
      this.scanCodeStep = 1
      if (this.activeKey === '2') {
        this.initWxLogin()
      }
    },

    /**
     * 微信扫码登录-初始化二维码
     */
    initWxLogin() {
      this.$nextTick(() => {
        this.wxLoginState = Math.ceil(Math.random() * 1000)
        new WxLogin({
          self_redirect: true,
          id: 'wx_login_qrcode',
          appid: settings.wxScanLoginConfig.appId,
          scope: 'snsapi_login',
          redirect_uri: settings.wxScanLoginConfig.redirectUri,
          state: this.wxLoginState,
          style: 'black',
          // 切换二维码登录样式，值为1时二维码登录将切换到新样式。
          // stylelite: 1,
          href:
            'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxle2Rpc3BsYXk6IG5vbmU7fSAgICAgCi5pbXBvd2VyQm94IC5xcmNvZGUgewogICAgZGlzcGxheTogYmxvY2s7CiAgICB3aWR0aDogMTc4cHg7CiAgICBtYXJnaW46IDE2cHggYXV0byAwOwogICAgYm9yZGVyOiAxcHggc29saWQgI2UyZTJlMjsKfQouaW1wb3dlckJveCAuc3RhdHVzIHsKICAgIHBhZGRpbmc6IDdweCAwOwogICAgdGV4dC1hbGlnbjogY2VudGVyOwp9Ci5pbXBvd2VyQm94ICAuc3RhdHVzX3R4dCB7CiAgICB0ZXh0LWFsaWduOiBsZWZ0Owp9Ci5pbXBvd2VyQm94IC5zdGF0dXMgcDpudGgtb2YtdHlwZSgyKSB7CiAgICBkaXNwbGF5OiBub25lOwp9',
          onReady: isReady => {
            this.isGetWxLoginCode = isReady
            console.log('isReady ===', isReady)
          }
        })
      })
    },

    /**
     * 微信扫码登录-接收微信码数据
     */
    wxLoginIframeEvent(event) {
      if (event.origin !== settings.wxScanLoginConfig.redirectOrigin) return
      if (Number(event.data.state) !== this.wxLoginState) return
      console.log('微信扫码登录收到子消息 ====', event)
      if (!this.isCheckAgree) {
        // 刷新微信登录二维码
        this.isGetWxLoginCode = false
        this.initWxLogin()
        this.$message.warning(`请勾选同意《${settings.loginAgreement.name}》`)
        return
      }
      const code = event.data.code
      if (code) {
        this.getWxUserInfo(code)
      } else {
        this.$message.error('操作失败，请重试~')
      }
    },

    /**
     * 微信扫码登录-获取绑定的用户信息
     */
    getWxUserInfo(wxCode) {
      console.log('getWxUserInfo wxCode ===', wxCode)
      loginApi
        .getUserBindInfo({ code: wxCode })
        .then(res => {
          const { code, msg, data } = res.data || {}
          if (code !== 200) {
            this.$message.error(msg)
            // 刷新微信二维码
            this.changeLoginType()
            return
          }
          this.wxUserInfo.unionId = data.unionId
          this.wxUserInfo.openId = data.openId
          // 已绑定手机号
          if (data.userList && data.userList.length) {
            const list = data.userList
            // 如果只有一个账号，直接登录
            if (list.length === 1) {
              this.selectCompany(list[0])
            } else {
              this.$refs.chooseLoginAccountModalRef &&
                this.$refs.chooseLoginAccountModalRef.open(list)
            }
          }
          // 未绑定（首次没绑定），走验证码登录（登录后自动绑定微信）
          else {
            console.log('未绑定（首次没绑定），走验证码登录（登录后自动绑定微信）')
            this.scanCodeStep = 2
          }
        })
        .catch(err => {
          this.$message.error(String(err) || '微信扫码登录失败')
          console.error('getWxUserInfo error:', err)
          // 刷新微信二维码
          this.changeLoginType()
        })
    },

    /**
     * 选择登录的公司
     */
    selectCompany(item) {
      if (this.activeKey === '2') {
        this.wxQrcodeLogin(item)
      }
    },

    /**
     * 微信扫码登录-通过码登录
     */
    async wxQrcodeLogin({ phone, companyId, roleId, userName, appId }) {
      try {
        const res = await loginApi.wxQrcodeLogin(
          {
            phone,
            userName,
            companyId,
            roleId,
            wxUnionId: this.wxUserInfo.unionId
          },
          { appId }
        )
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)

        cookie.setCookie('token', data.token, 7)
        cookie.setCookie('uid', data.userId, 7)
        sessionStorage.setItem('userInfo', JSON.stringify(data))
        sessionStorage.setItem('asrId', data.asrId)
        //超管或广告运营
        if ([1, 4, 6].indexOf(data.userType) !== -1) {
          this.$router.push('/index')
        } else if (data.userType == 3) {
          //工程
          this.$router.push('/adPackage')
        } else {
          this.$router.push('/channelAdPlan')
        }

        // 缓存本次登录方式
        localStorage.setItem('lastLoginType', this.activeKey)
      } catch (err) {
        console.error('wxQrcodeLogin error:', err)
      }
    },

    init() {
      if (window.sessionStorage.checkNick == 'true') {
        this.checkNick = true
      } else {
        this.checkNick = false
      }
      if (this.checkNick) {
        this.form.setFieldsValue({ account: window.sessionStorage.account })
        this.form.setFieldsValue({ passwork: window.sessionStorage.passwork })
      } else {
        this.form.setFieldsValue({ account: '' })
        this.form.setFieldsValue({ passwork: '' })
      }
    },
    emitEmpty() {
      this.$refs.accountInput.focus()
      this.userName = ''
    },
    check() {
      let oThis = this
      this.form.validateFields(err => {
        if (!err) {
          // 获取账号和密码
          let account = {
            username: this.$refs.accountInput.value,
            password: this.$refs.passworkInput.value
          }
          // this.$message.loading('Action in progress..');
          this.spinning = true
          api
            .postApi('/login/loginIn', account)
            .then(res => {
              let userInfo = res.data.data
              if (res.data.code == 200) {
                cookie.setCookie('token', res.data.data.token, 7)
                cookie.setCookie('uid', res.data.data.userId, 7)
                sessionStorage.setItem('account', this.$refs.accountInput.value)
                sessionStorage.setItem('passwork', this.$refs.passworkInput.value)
                sessionStorage.setItem('userInfo', JSON.stringify(res.data.data))
                sessionStorage.setItem('asrId', res.data.data.asrId)
                //超管或广告运营
                if ([1, 4, 6].indexOf(userInfo.userType) !== -1) {
                  this.$router.push('/index')
                } else if (userInfo.userType == 3) {
                  //工程
                  this.$router.push('/adPackage')
                } else {
                  this.$router.push('/channelAdPlan')
                }
              } else {
                oThis.$message.error(res.data.msg)
              }
            })
            .catch(res => {
              oThis.$message.error('登陆信息有误', 1)
            })
            .finally(res => {
              this.spinning = false
            })
        }
      })
    },
    check2() {
      let oThis = this
      let account = {
        code: oThis.GetRequest('code')
      }
      this.spinning = true
      api
        .postApi('/login/login?code=' + oThis.GetRequest('code'))
        .then(res => {
          let userInfo = res.data.data
          if (res.data.code == 200) {
            cookie.setCookie('token', res.data.data.token, 7)
            cookie.setCookie('uid', res.data.data.userId, 7)
            sessionStorage.setItem('account', this.$refs.accountInput.value)
            sessionStorage.setItem('passwork', this.$refs.passworkInput.value)
            sessionStorage.setItem('userInfo', JSON.stringify(res.data.data))
            //超管或广告运营
            if ([1, 4, 6].indexOf(userInfo.userType) !== -1) {
              this.$router.push('/index')
            } else if (userInfo.userType == 3) {
              //工程
              this.$router.push('/adPackage')
            } else {
              this.$router.push('/channelAdPlan')
            }
          } else {
            oThis.$message.error(res.data.msg)
          }
        })
        .catch(res => {
          oThis.$message.error('登陆信息有误', 1)
        })
        .finally(res => {
          this.spinning = false
        })
    },

    handleChange(e) {
      this.checkNick = e.target.checked
      if (this.checkNick) {
        sessionStorage.setItem('checkNick', 'true')
      } else {
        sessionStorage.setItem('checkNick', 'false')
      }
      if (this.checkNick) {
        sessionStorage.setItem('account', this.$refs.accountInput.value)
        sessionStorage.setItem('passwork', this.$refs.passworkInput.value)
      } else {
        sessionStorage.setItem('account', '')
        sessionStorage.setItem('passwork', '')
      }
    },
    /**
     * [获取URL中的参数名及参数值的集合]
     * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
     * @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
     * @return {[string]}       [参数集合]
     */
    GetRequest(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg) //获取url中"?"符后的字符串并正则匹配
      var context = ''
      if (r != null) context = r[2]
      reg = null
      r = null
      return context == null || context == '' || context == 'undefined' ? '' : context
    },

    /**
     * 读取上次缓存登录方式
     */
    getLoginTypeCache() {
      const lastLoginType = localStorage.getItem('lastLoginType')
      this.isCheckAgree = !!lastLoginType
      if (lastLoginType) {
        this.activeKey = lastLoginType
        this.changeLoginType()
      }
    }
  },

  mounted() {
    /**
     * 初始化获取地区信息
     */
    this.init()
    if (this.GetRequest('code')) {
      this.check2()
    }
    // 父页面接收 iframe 的回复
    window.addEventListener('message', this.wxLoginIframeEvent)
    this.getLoginTypeCache()
  },

  beforeDestroy() {
    // 清除监听事件
    window.removeEventListener('message', this.wxLoginIframeEvent)
  }
}
</script>
<style scoped lang="scss">
.spin-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /deep/ .ant-spin-spinning {
    max-height: unset !important;
  }
}

.m-login {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #f0f2f5;
  z-index: 999;
  .u-login-bg {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 510px;
    background: linear-gradient(135deg, rgba(118, 201, 252, 1) 0%, rgba(92, 163, 247, 1) 100%);
  }
  .m-login-content-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    .m-login-content-imgs {
      width: 60%;
      position: relative;
      .u-login-img {
        position: absolute;
        // width: 50%;
        width: 509px;
        height: 644px;
        left: 150px;
        top: 100px;
      }
      .u-login-cube1 {
        position: absolute;
        width: 38px;
        left: 208px;
        top: 35px;
        animation: cube1Move 1.2s ease-in-out infinite alternate;
      }
      .u-login-shadow1 {
        position: absolute;
        width: 38px;
        left: 160px;
        top: 150px;
        animation: shadow1Move 1.2s ease-in-out infinite alternate;
      }
      .u-login-cube2 {
        position: absolute;
        width: 32px;
        left: 175px;
        top: 680px;
        animation: cube2Move 1.8s ease-in-out infinite alternate;
      }
      .u-login-shadow2 {
        position: absolute;
        width: 32px;
        left: 147px;
        top: 740px;
        animation: shadow2Move 1.8s ease-in-out infinite alternate;
      }
      .u-login-cube3 {
        position: absolute;
        left: 90%;
        top: 60%;
        animation: cube3Move 1.6s ease-in-out infinite alternate;
      }
      .u-login-shadow3 {
        position: absolute;
        left: 85%;
        top: 69%;
        animation: shadow3Move 1.6s ease-in-out infinite alternate;
      }
    }
    .m-login-content-box {
      width: 40%;
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: flex-end;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding-top: 130px;
      margin-right: 64px;
      .m-login-box-wrap {
        background: #ffffff;
        -webkit-box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        width: 468px;
        height: 550px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 66px 50px 89px;
        .u-login-box-title {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          width: 175px;
          height: 80px;
          margin: 0 auto 40px;
        }
      }
      .u-login-box-footer {
        position: absolute;
        bottom: 24px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 20px;
      }
      .ant-form-item-control-wrapper {
        width: 100%;
      }
    }
  }
}

@keyframes cube1Move {
  from {
    top: 35px;
  }
  to {
    top: 50px;
  }
}
@keyframes shadow1Move {
  from {
    left: 160px;
    top: 150px;
  }
  to {
    left: 150px;
    top: 170px;
  }
}
@keyframes cube2Move {
  from {
    top: 680px;
  }
  to {
    top: 660px;
  }
}
@keyframes shadow2Move {
  from {
    left: 147px;
    top: 740px;
  }
  to {
    left: 135px;
    top: 750px;
  }
}
@keyframes cube3Move {
  from {
    top: 60%;
  }
  to {
    top: 56%;
  }
}
@keyframes shadow3Move {
  from {
    left: 85%;
    top: 69%;
  }
  to {
    left: 82%;
    top: 72%;
  }
}
.f-icon-color {
  color: rgba(0, 0, 0, 0.25);
}
.ant-form-explain {
  text-align: left;
}

.tab_wrapper {
  padding: 0 24px;
  /deep/ .ant-tabs-nav-scroll {
    text-align: center;
  }
  /deep/ .ant-tabs-nav {
    margin-bottom: 20px;
  }
  /deep/ .ant-tabs-bar {
    margin: 0;
    border-color: transparent;
  }
  /deep/ .ant-tabs-tab {
    padding: 14px 16px;
  }
}

.wx_code_wrapper {
  height: 247px;
  width: 296px;
  margin: 0 auto;
}

.check_agree_box {
  margin-top: 12px;
  text-align: center;
}
</style>

<style>
.wx_login_qrcode iframe {
  height: 247px;
  width: 296px;
  border: none;
  outline: none;
  display: block;
  margin: 0 auto;
  text-align: center;
}
</style>
